import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-play",
  "use": "icon-play-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-play\"><defs><style type=\"text/css\"></style></defs><path d=\"M512.137635 65.043389c-247.224638 0-447.515337 200.358237-447.515337 447.515337 0 247.158123 200.290699 447.51636 447.515337 447.51636 247.156076 0 447.51636-200.358237 447.51636-447.51636C959.653995 265.401626 759.293711 65.043389 512.137635 65.043389zM368.810299 725.264175 368.810299 305.923528l363.195929 209.636554L368.810299 725.264175z\" p-id=\"13244\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/play.svg
// module id = ufmG
// module chunks = 31